/**
 * Iterates over elements and returns what their absolute positions should be
 * based on their style.width and style.height properties. If either width
 * or height isn't specified this will throw an error
 * @param {Array<object>} elements Should be an array of objects with width and
 * height props.
 * @param {object} width The width of the bounding container
 * @returns {Array<object>}
 */
function calculateAbsolutePositions(elements, width) {
  var positions = [],
    filledLeft = 0,
    filledTop = 0
  elements.forEach(el => {
    var pos = { left: filledLeft, top: filledTop }
    if (isPostOutOfBounds({ ...pos, ...el }, width)) {
      pos.left = 0
      // This assumes that all heights are uniform, will need to be updated
      // if that's not the case
      pos.top += el.height
      filledLeft = el.width
      filledTop += el.height
    } else {
      filledLeft += el.width
    }
    positions.push(pos)
  })
  return {
    positions,
    // Assumes all heights are uniform
    height: filledTop + (elements[0] ? elements[0].height : 0),
  }
}

export default calculateAbsolutePositions

/**
 * Determine if the position falls outside the right limit of the bounds
 * @param {object} pos Expects props left, top, width and height
 * @param {object} width The width of the bounding container
 * @returns {boolean}
 */
export function isPostOutOfBounds(elementBounds, width) {
  return width - elementBounds.left - elementBounds.width < 0
}



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/FlyerCodesGiveOutWidget/DraggableCodeList/calculateAbsolutePositions.js